module.exports = __webpack_public_path__ + "media/add-ons/recruitment@3x-ba05d957.png";